// extracted by mini-css-extract-plugin
export default {"confirmCancelAllDialog":"confirmCancelAllDialog-OuaFY","text":"text-MMBkk","button":"button-JxHGd","options":"options-glMds"};